import React, {useState} from "react";
import {Dialog} from "../../../../designSystem/components/Dialog";
import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {NextStepButton} from "../../../../widgets/NextStepButton";
import {NewApplicationForm} from "../NewApplicationForm";

import {DEFAULT_PATIENT_HAS_TUBE} from "../../model/defaultPatientHasTube";
import {DEFAULT_CURRENT_HOME_CARE_SERVICE} from "../../model/defaultCurrentHomeService";
import {useCreateCase} from "../../hooks/useCreateCase";

export const NewApplicationStep2Feature = () => {
  const [applicantName, setApplicantName] = useState<string>('');
  const [applicantOrganization, setApplicantOrganization] = useState<string>('');
  const [applicantTitle, setApplicantTitle] = useState<string>('');
  const [applicantPhonePrefix, setApplicantPhonePrefix] = useState<string>('');
  const [applicantPhone, setApplicantPhone] = useState<string>('');
  const [patientName, setPatientName] = useState<string>('');
  const [patientId, setPatientId] = useState<string>('');
  const [patientGender, setPatientGender] = useState<string>('');
  const [region, setRegion] = useState<string>('');
  const [addressPart, setAddressPart] = useState<string>('');
  const [yearRoc, setYearRoc] = useState<string>('');
  const [month, setMonth] = useState<string>('');
  const [day, setDay] = useState<string>('');
  const [patientHasTube, setPatientHasTube] = useState<object>(DEFAULT_PATIENT_HAS_TUBE);
  const [primaryCaregiverName, setPrimaryCaregiverName] = useState<string>('');
  const [relationshipWithPatient, setRelationshipWithPatient] = useState<string>('');
  const [contactNumber, setContactNumber] = useState<string>('')
  const [contactNumberPrefix, setContactNumberPrefix] = useState<string>('');
  const [currentHomeCareService, setCurrentHomeCareService] = useState<object>(DEFAULT_CURRENT_HOME_CARE_SERVICE);
  const [description, setDescription] = useState<string>('');
  const [dialogContent, setDialogContent] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const handleCloseDialog = () => setDialogContent('');
  const {handleCreateCase} = useCreateCase({
    applicantName,
    setApplicantName,
    applicantOrganization,
    applicantTitle,
    applicantPhone,
    applicantPhonePrefix,
    patientName,
    patientId,
    patientGender,
    region,
    addressPart,
    yearRoc,
    month,
    day,
    patientHasTube,
    primaryCaregiverName,
    relationshipWithPatient,
    contactNumber,
    contactNumberPrefix,
    currentHomeCareService,
    description,
    setDialogContent,
    setMessage
  });

  return (
    <React.Fragment>
      <FormPageLayout
        height={NAVIGATION_BAR_HEIGHT.LARGE}
        body={
          <NewApplicationForm
            applicantName={applicantName}
            applicantOrganization={applicantOrganization}
            applicantTitle={applicantTitle}
            applicantPhone={applicantPhone}
            applicantPhonePrefix={applicantPhonePrefix}
            patientName={patientName}
            patientId={patientId}
            patientGender={patientGender}
            region={region}
            addressPart={addressPart}
            yearRoc={yearRoc}
            month={month}
            day={day}
            patientHasTube={patientHasTube}
            primaryCaregiverName={primaryCaregiverName}
            relationshipWithPatient={relationshipWithPatient}
            contactNumber={contactNumber}
            contactNumberPrefix={contactNumberPrefix}
            currentHomeCareService={currentHomeCareService}
            description={description}
            onChangeApplicantName={value => setApplicantName(value)}
            onChangeApplicantOrganization={value => setApplicantOrganization(value)}
            onChangeApplicantTitle={value => setApplicantTitle(value)}
            onChangeApplicantPhonePrefix={value => setApplicantPhonePrefix(value)}
            onChangeApplicantPhone={value => setApplicantPhone(value)}
            onChangePatientName={value => setPatientName(value)}
            onChangePatientId={value => setPatientId(value)}
            onChangePatientGender={value => setPatientGender(value)}
            onChangeRegion={value => setRegion(value)}
            onChangeAddressPart={value => setAddressPart(value)}
            onChangeYearRoc={value => setYearRoc(value)}
            onChangeMonth={value => setMonth(value)}
            onChangeDay={value => setDay(value)}
            onChangePatientHasTube={value => setPatientHasTube(value)}
            onChangePrimaryCaregiverName={value => setPrimaryCaregiverName(value)}
            onChangeRelationshipWithPatient={value => setRelationshipWithPatient(value)}
            onChangeContactNumber={value => setContactNumber(value)}
            onChangeContactNumberPrefix={value => setContactNumberPrefix(value)}
            onChangeCurrentHomeCareService={value => setCurrentHomeCareService(value)}
            onChangeDescription={value => setDescription(value)}
          />
        }
        footer={
          <NextStepButton onClick={handleCreateCase} />
        }
      />
      <Dialog isOpen={dialogContent !== ''}>
        {dialogContent === 'message' ? (
          <TwoButtonDialog
            type="warning"
            title={message}
            leftLabel="OK"
            leftOnClick={handleCloseDialog}
            leftIconName="fa-check"
          />
        ) : null}
      </Dialog>
    </React.Fragment>
  );
}